import { IStore } from 'store/configureStore';
import { selectDealsState } from 'modules/settings/submodules/clients/deals/store/selectors';

export const selectIsDealStatusUpdating = (state: IStore) => {
    const dealsState = selectDealsState(state);
    return dealsState.isDealStatusUpdating;
};
